import { SVGIconComponent } from './types';

export const LockerLR: SVGIconComponent = ({ className, color, style }) => (
  <svg
    version="1.0"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 25 36"
    xmlSpace="preserve"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Locker-Sizes_x2F_locker-LR">
      <g id="locker-L" transform="translate(0.000003, 4.000000)">
        <g id="L">
          <path
            id="path-1_00000181080293056452262720000006591902827415226774_"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="currentColor"
            d="M12.8,0l11.5,5.5c0.2,0.1,0.3,0.3,0.3,0.5
				l0,16.8c0,0.2-0.1,0.3-0.2,0.4l-11.6,8.4l0,0c0,0,0,0,0,0l0,0c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0
				c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0
				c0,0,0,0,0,0l-12-6.9C0.1,24.7,0,24.5,0,24.3V7.9c0-0.3,0.2-0.5,0.4-0.5l11.9-7.3C12.5,0,12.7,0,12.8,0z M1,8.8V24l11,6.3V14.9
				L1,8.8z M23.6,7.2L13,14.8v15.4l10.6-7.6V7.2z M12.6,1.1L1.5,7.9L12.4,14l10.7-7.8L12.6,1.1z"
          />
        </g>
      </g>
      <g id="Shape" transform="translate(12.000000, 10.869155)">
        <g id="Mask"></g>
        <mask
          maskUnits="userSpaceOnUse"
          x="-5"
          y="5.1"
          width="14"
          height="16"
          id="mask-4_00000017492529705084456630000011880055298696552576_"
        >
          <g>
            <polygon
              id="path-3_00000126311286672864524360000013004760925681274017_"
              fillRule="evenodd"
              clipRule="evenodd"
              fill="currentColor"
              points="0,7.9 11,0 11,26.1 0,26.1 				
					"
            />
          </g>
        </mask>
        <path
          mask="url(#mask-4_00000017492529705084456630000011880055298696552576_)"
          fill="currentColor"
          d="M8.7,16.3l-1.1-0.6l0.9-0.4c0.3-0.1,0.4-0.5,0.2-0.8c-0.1-0.3-0.5-0.4-0.7-0.3l-1.6,0.8l-2.3-1.3
			c0.1-0.4,0.1-0.8,0-1.2l2.3-1.3L8.1,12c0.3,0.1,0.6,0,0.7-0.3c0.1-0.3,0-0.6-0.2-0.8l-0.9-0.4l1.1-0.6C9,9.7,9.1,9.4,8.9,9.1
			C8.8,8.9,8.4,8.8,8.2,8.9L7.1,9.5l0.1-1C7.2,8.2,6.9,8,6.6,8C6.3,7.9,6,8.2,6,8.5l-0.1,1.7l-2.3,1.3c-0.3-0.3-0.6-0.5-1-0.6V8.3
			l1.5-1C4.2,7.2,4.3,7.1,4.3,7c0-0.2,0-0.3-0.1-0.4C4.1,6.4,4,6.3,3.9,6.3c-0.2,0-0.3,0-0.4,0.1L2.6,6.9V5.7c0-0.3-0.3-0.6-0.6-0.6
			S1.4,5.4,1.4,5.7v1.2L0.6,6.3C0.5,6.3,0.3,6.2,0.2,6.2C0,6.3-0.1,6.4-0.2,6.5c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.2,0.1,0.3,0.3,0.4
			l1.5,1v2.6C1,11,0.7,11.2,0.4,11.5l-2.3-1.3L-2,8.5c0-0.3-0.3-0.6-0.6-0.5c-0.3,0-0.6,0.3-0.5,0.6l0.1,1l-1.1-0.6
			c-0.3-0.1-0.6,0-0.8,0.2C-5,9.4-5,9.7-4.7,9.9l1.1,0.6L-4.5,11c-0.3,0.1-0.4,0.5-0.3,0.8S-4.3,12.1-4,12l1.6-0.8l2.3,1.3
			c-0.1,0.4-0.1,0.8,0,1.2l-2.3,1.3L-4,14.3c-0.1-0.1-0.3-0.1-0.4,0c-0.1,0-0.3,0.2-0.3,0.3c-0.1,0.1-0.1,0.3,0,0.4
			c0.1,0.1,0.2,0.3,0.3,0.3l0.9,0.4l-1.1,0.6c-0.1,0.1-0.2,0.2-0.3,0.3c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.4,0.3
			c0.2,0,0.3,0,0.4-0.1l1.1-0.6l-0.1,1c0,0.3,0.2,0.6,0.5,0.6h0c0.3,0,0.6-0.2,0.6-0.5l0.1-1.7l2.3-1.3c0.3,0.3,0.6,0.5,1,0.6V18
			l-1.5,1c-0.2,0.2-0.3,0.5-0.1,0.8C0,20,0.4,20,0.6,19.9l0.8-0.6v1.2c0,0.3,0.3,0.6,0.6,0.6s0.6-0.3,0.6-0.6v-1.2l0.8,0.6
			C3.6,20,3.7,20,3.9,20c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2-0.1-0.3-0.3-0.4l-1.5-1v-2.6C3,15.2,3.4,15,3.6,14.7
			L5.9,16L6,17.8c0,0.3,0.3,0.5,0.6,0.5h0c0.3,0,0.5-0.3,0.5-0.6l-0.1-1l1.1,0.6c0.3,0.1,0.6,0,0.8-0.2C9.1,16.8,9,16.5,8.7,16.3
			L8.7,16.3z M2,14.3c-0.5,0-0.9-0.3-1.1-0.7c-0.2-0.4-0.1-0.9,0.2-1.2C1.5,12,2,11.9,2.5,12.1c0.4,0.2,0.7,0.6,0.7,1.1
			c0,0.3-0.1,0.6-0.3,0.8S2.3,14.3,2,14.3L2,14.3z"
        />
      </g>
    </g>
  </svg>
);
